import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

const CalendarPage = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Calendar" pageType="Apps" />
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
        initialView="dayGridMonth"
        weekends={true}
        headerToolbar={{
          right: "today prev,next",
          left: "title",
        }}
      />
    </React.Fragment>
  );
};

export default CalendarPage;
